const VerticalSeparator = ({ classes }: { classes?: string }) => {
  return <div className={`w-px h-8 lg:h-[55px] bg-black/8 ${classes ? classes : ""}`} />;
};

export default VerticalSeparator;
